/**
 * 🔴 THE APP'S NAME, DRAWN ONE WAY IN EVERY APP — design-system DS-11b1 (§1.7; F30, F299).
 *
 * The accent "W" square and the app's word beside it: "Workbook" in the back office's sidebar, "Portal" and "System"
 * in their bars. The square is decoration (`aria-hidden`): the word is the name, so a screen reader reads "Workbook",
 * not "W Workbook". The same mark is the apps' icon (`web/src/assets/brand/icon.svg`; owner, 2026-10-07: the accent
 * "W" until real artwork arrives). `tone="neutral"` is the console's: the operator's tool is not the product's colour
 * (PLAN.md, DS-11).
 *
 * Borrowed by the portal and the console by its own file, never through the kit barrel (both `BORROWABLE` lists).
 * Each app sizes the square where it sits (app.css's sidebar, system.css's bar); `.wb-mark` is the portal's 22px.
 */
export function Wordmark({ word, tone }: { word: string; tone?: 'neutral' }) {
  return (
    <>
      <span className={tone ? 'wb-mark wb-mark--neutral' : 'wb-mark'} aria-hidden="true">
        W
      </span>
      <span className="wb-mark__word">{word}</span>
    </>
  );
}
